var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsCalendarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 5.33594H7.99984C5.05432 5.33594 2.6665 7.72375 2.6665 10.6693V24.0026C2.6665 26.9481 5.05432 29.3359 7.99984 29.3359H23.9998C26.9454 29.3359 29.3332 26.9481 29.3332 24.0026V10.6693C29.3332 7.72375 26.9454 5.33594 23.9998 5.33594Z",
    stroke: "#006BD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 2.66797V8.0013M21.3332 2.66797V8.0013M2.6665 13.3346H29.3332",
    stroke: "#006BD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCalendarActive);
export default __webpack_public_path__ + "static/media/icons-calendar-active.351f2b17e109f15517cf724a25c24db3.svg";
export { ForwardRef as ReactComponent };